(function($) {
  stickyHeaderCheck();

    $(window).scroll(function () {
		  stickyHeaderCheck();
    });

    function stickyHeaderCheck() {
      let isStickyTime = $(document).scrollTop() > 120;

      $('.site-header').toggleClass('is-sticky', isStickyTime);
      $('.special-message').toggleClass('is-sticky', isStickyTime);
      $('#front-chat-iframe').toggleClass('is-visible', isStickyTime);
    }

})(jQuery);
